import { createIcon } from '@chakra-ui/react';

export const CheckMarkCircle = createIcon({
  displayName: 'CheckMarkCircle',
  viewBox: '0 10 68 40',
  path: (
    <g id="Check" transform="translate(-95 -238)">
      <g
        id="Ellipse_1"
        data-name="Ellipse 1"
        transform="translate(95 238)"
        stroke="currentColor"
        strokeWidth="3"
      >
        <circle cx="32" cy="32" r="32" stroke="none" fill="none" />
        <circle cx="32" cy="32" r="30.5" fill="none" />
      </g>
      <g
        id="Check_Mark_-_S"
        data-name="Check Mark - S"
        transform="translate(109.539 257.655)"
      >
        <path
          id="Check_Mark_-_S-2"
          data-name="Check Mark - S"
          d="M35.565,2.621a1.749,1.749,0,0,0-2.523,0L12.628,23.1,3.5,14.119a1.749,1.749,0,0,0-2.491,0,1.806,1.806,0,0,0,0,2.519L11.4,26.876a1.91,1.91,0,0,0,1.262.517,1.813,1.813,0,0,0,1.262-.549l21.643-21.8A1.774,1.774,0,0,0,35.565,2.621Z"
          transform="translate(-0.502 -2.083)"
          fill="currentColor"
        />
      </g>
    </g>
  ),
});
